import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "options", "placeholder", "disabled"];
import Controllable from '../decorators/Controllable';
import PropTypes from 'prop-types';
import { Component } from 'react';
import classNames from 'classnames';
import { INPUT_SIZE_OPTIONS } from './InputConstants';
import { FieldsetContext } from '../context/FieldsetContext';

/** @internal */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PLACEHOLDER = '__PLACEHOLDER__';
const renderOption = ({
  disabled,
  text = '',
  value = '',
  options: nestedOptions
}) => nestedOptions ? /*#__PURE__*/_jsx("optgroup", {
  disabled: disabled,
  label: text || value,
  children: nestedOptions.map(renderOption)
}, text + value) : /*#__PURE__*/_jsx("option", {
  disabled: disabled,
  value: value,
  children: text || value
}, text + value);
class UISelectInput extends Component {
  render() {
    const _this$props = this.props,
      {
        className,
        options,
        placeholder,
        disabled
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const {
      size: fieldSize
    } = this.context;
    return /*#__PURE__*/_jsx("div", {
      className: classNames("hs-custom-select private-form__control private-form__select form-control display-inline-block", INPUT_SIZE_OPTIONS[fieldSize], className, disabled && 'private-form__control--disabled'),
      children: /*#__PURE__*/_jsxs("select", Object.assign({}, rest, {
        disabled: disabled,
        children: [placeholder && /*#__PURE__*/_jsx("option", {
          disabled: true,
          value: PLACEHOLDER,
          children: placeholder
        }, "placeholder"), options.map(renderOption)]
      }))
    });
  }
}
UISelectInput.defaultProps = {
  value: PLACEHOLDER
};
UISelectInput.displayName = 'UISelectInput';
UISelectInput.contextType = FieldsetContext;
UISelectInput.propTypes = {
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({
    disabled: PropTypes.bool,
    text: PropTypes.string,
    value: PropTypes.any.isRequired
  }).isRequired).isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.string
};
export default Controllable(UISelectInput);